// react
import React from 'react'
import { Link } from 'react-router-dom'

// components
import Header from '_components/header'
import ListView from '_components/list-view'
import ItemInfoCell from '_components/item-info-cell'
import ModalCloneAudience from '_components/custom-audiences/modal-clone-audience'
import ModalMergeAudience from '_components/custom-audiences/modal-merge-audience'
import BatchSidebar, { ACTIONS } from '_components/batch-sidebar'

//lib
import Events from '@st-operations/uikit/Events.js'
import Storage from '@st-operations/uikit/Storage.js'
import bulkUpdate from '_lib/bulkUpdate.js'

// services
import { mergeAudiences } from '_services/audience'

// Styles
import './styles.scss'

// BrandedAudiences Page
class BrandedAudiencesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      batch_percentage: 0,
      error: null,
      isModalCloneOpen: false,
      isModalMergeOpen: false,
      selectedAudiences: [],
      statuses: ['draft', 'approved', 'processed'],
      taxonomies: [],
      remountKey: 0,
    }
    this.listViewItemsRef = React.createRef([])
  }

  softRefresh = (error) => !error && this.setState({ remountKey: Math.random() })

  componentDidMount() {
    this.loadTaxonomies()
  }

  clone = (audiences) => {
    const ids = Object.keys(audiences)
    this.startBatchProcess(ids)
    let bulkAction = {
      body: {},
      ids,
      isBrandedAudience: true,
      audiences,
      method: 'post',
      url: `/custom-audiences/load-ab`,
    }
    bulkUpdate(bulkAction, this.updateBatchProgress, this.softRefresh)
  }

  startBatchProcess = (ids) => {
    Storage.set('abort_batch', false)
    Events.emit('set_batch_process', true)
    this.setState({ batch_percentage: 0, batch_size: ids.length ?? ids.size })
  }

  updateBatchProgress = () => {
    let { batch_percentage, batch_size } = this.state
    batch_percentage += 1 / batch_size
    this.setState({ batch_percentage })
  }

  loadTaxonomies = () => {
    window._api.get('/legacy-taxonomies', { is_branded: true }, (error, resp) => {
      this.setState({ error, taxonomies: resp.items })
    })
  }

  openModalClone = (items, resourceOptimized) => {
    this.setState({
      isModalCloneOpen: true,
      selectedAudiences: items,
      resourceOptimized,
    })
  }

  openModalMerge = (items) => {
    this.setState({
      isModalMergeOpen: true,
      selectedAudiences: items,
    })
  }

  merge = (payload) => {
    mergeAudiences(payload)
      .then((response) => {
        const id = response?.insertedIds?.[0]
        id && _history.push(`/audience-creator/${id}`)
      })
      .catch((error) => toast.error('Error merging audience.'))
  }

  search(qs, next) {
    qs.kind = 'taxonomy'
    qs.is_branded = true
    window._api.get('/legacy-audiences/search', qs, next)
  }

  handleSelectionChange = ({ action, items }) => {
    const selectedEntities = this.listViewItemsRef.current.filter(({ _id }) => items.includes(_id))
    Events.emit('ListView-selection', { action, items, entities: selectedEntities })
  }

  handleBatchSidebarAction = (action, items) => {
    switch (action) {
      case ACTIONS.CLONE:
        return this.openModalClone(items)
      case ACTIONS.CLONE_RESOURCE_OPTIMIZED:
        return this.openModalClone(items, true)
      case ACTIONS.MERGE:
        return this.openModalMerge(items)
    }
  }

  render() {
    let {
      batch_percentage,
      batch_size,
      error,
      isModalCloneOpen,
      isModalMergeOpen,
      selectedAudiences,
      statuses,
      taxonomies,
      remountKey,
    } = this.state

    return (
      <div id="branded-audiences" key={remountKey}>
        <If condition={error}>
          <p>{error.message}</p>
        </If>

        <Header
          title="Clone Branded Audiences"
          actions={[
            { children: 'Create New Taxonomy', href: 'https://data.sharethis.com/create-taxonomy' },
          ]}
        />
        <div className="batch-sidebar__list-view-wrapper">
          <ListView
            className="st-list-view--has-sidebar"
            showCheckboxes={true}
            batch_percentage={batch_percentage}
            batch_size={batch_size}
            itemsRef={this.listViewItemsRef}
            onSelectionChange={this.handleSelectionChange}
            columns={[
              {
                name: 'Name',
                key: 'name',
                render: (item) => (
                  <ItemInfoCell
                    key={`item-${item.index}`}
                    fields={['status']}
                    item={item}
                    value={item}
                    //href={`https://data.sharethis.com/audience/${item._id}`}
                  />
                ),
                sortable: true,
              },
              {
                key: 'taxonomy.name',
                name: 'Taxonomy',
                render: (item) => (
                  <Link key={`item-${item.index}`} to={`/taxonomies/${item.taxonomy._id}`}>
                    {item.taxonomy.name}
                  </Link>
                ),
              },
              {
                format: 'metric',
                key: 'est_size',
                name: 'Size',
                sortable: true,
              },
              {
                format: 'date',
                key: 'updated_at',
                name: 'Last Updated',
                sortable: true,
              },
            ]}
            creatable={false}
            entities="branded-audiences"
            filters={[
              {
                name: 'taxonomy',
                options: taxonomies,
                normal: 'normalSize',
                className: 'branded-audiences__taxonomy',
              },
              { name: 'status', options: statuses },
            ]}
            filter_on_load={{
              status: 'processed',
              taxonomy: { _id: '591f77575665ae7d29b0c543', name: 'ShareThis Verticals' },
            }}
            fields={['name', 'status', 'taxonomy.name', 'est_size', 'updated_at']}
            page_size={50}
            search={this.search}
            searchable={true}
            sort_key={'updated_at'}
            sort_dir={-1}
          />
          <BatchSidebar
            onConfirm={this.handleBatchSidebarAction}
            actions={[ACTIONS.CLONE, ACTIONS.CLONE_RESOURCE_OPTIMIZED, ACTIONS.MERGE]}
          />
        </div>

        {/* Batch Progress Dialog */}
        <ModalCloneAudience
          selectedAudiences={selectedAudiences}
          isModalCloneOpen={isModalCloneOpen}
          clone={this.clone}
          closeModal={() => this.setState({ isModalCloneOpen: false })}
          resourceOptimized={this.state.resourceOptimized}
        />
        <ModalMergeAudience
          selectedAudiences={selectedAudiences}
          isModalMergeOpen={isModalMergeOpen}
          merge={this.merge}
          closeModal={() => this.setState({ isModalMergeOpen: false })}
        />
      </div>
    )
  }
}

// export
export default BrandedAudiencesPage
